export default __webpack_public_path__ + "static/media/chat.f459c2a5.svg";